// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"22ade87c","94":"618f30f5","343":"57e699be","538":"6b3c7eea","722":"204d8595","724":"0c852a6a"}[chunkId] + ".chunk.js";
};